<template>
  <div class="overlay">
    <div class="page-lock">
      <div class="page-logo">
        <a class="brand" href="/">
          <img src="/static/pages/img/logo.png" alt="logo">
        </a>
      </div>
      <div class="page-body">
        <div class="lock-head"> System Maintenance</div>
        <div class="lock-body maintenance-body">
          <div class="lock-cont">
            <div class="lock-item lock-item-full">
              <p v-html="maintenance_message"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="page-footer-custom">© {{ getCurrentYear }} CaseMGR Solutions, Inc. All Rights Reserved.</div>
    </div>
  </div>
</template>
<script>
  import {mapActions, mapGetters} from "vuex";
  import Router from '@/router';

  export default {
    methods: {
      ...mapActions([
        'checkMaintenanceStatus'
      ])
    },
    computed: {
      ...mapGetters({
        maintenance_mode: 'getMaintenanceStatus',
        maintenance_message: 'getMaintenanceMessage'
      }),
      getCurrentYear:function(){
          const d = new Date();
          let year = d.getFullYear();
          return year
      }
    },
    mounted() {
      this.checkMaintenanceStatus();
    },
    watch: {
      'maintenance_mode': function () {
        if (this.maintenance_mode === false) {
          Router.push('/login');
        }
      }
    }
  }
</script>
<style scoped>
  .overlay {
    background-color: #ffffff;
    min-height: 100vh;
    min-width: 100vw;
    position: absolute;
  }

  .brand img {
    width: 100%;
  }

  .maintenance-body {
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// Maintenance.vue?0a8bc60b